import Personalization from 'theme/atoms/Personalization'
import * as t from './types'
import * as React from 'react'
import { FetchContentResult } from 'utils/dy-hybrid/endpoints/fetchContent'

const mapDy =
  (prevProps: t.Props) =>
  (config: FetchContentResult<t.DyResponse>): t.Props => {
    const content = config.content

    const dyItems = content.items.map((item) => {
      return {
        name: item.Text,
        imgSrc: item.Image,
        link: item.Link,
        logo: item.BrandImage
      }
    })

    return {
      gridArea: prevProps.gridArea,
      dySelector: prevProps.dySelector || '',
      showDefaultDataByControlGroup: prevProps.showDefaultDataByControlGroup,
      label: content.Headline || null,
      linkLabel: content.Linktext,
      link: content.Link,
      items: dyItems,
      style: 'logo',
      context: prevProps.context,
      eecTracking: prevProps.eecTracking
    }
  }

export default function withDy(
  Component: React.JSXElementConstructor<t.Props>
) {
  return function Wrapper(props: t.Props) {
    if (!props.dySelector) return <Component {...props} />
    return (
      <Personalization<t.Props, t.DyResponse>
        processResponse={mapDy(props)}
        selector={props.dySelector}
        showDefaultDataByControlGroup={props.showDefaultDataByControlGroup}
        shape={[
          'object',
          {
            Headline: ['optional', 'string'],
            Linktext: 'string',
            Link: 'string',
            items: [
              'array',
              [
                'object',
                {
                  BrandImage: 'string',
                  Link: 'string',
                  Text: 'string',
                  Image: 'string'
                }
              ]
            ]
          }
        ]}
        initialData={{ ...props }}
        strategy="BLUR"
        render={(data) => <Component {...data} />}
      />
    )
  }
}
